import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import store from "./app/store";

const root = document.querySelectorAll("div[data-js='React']");
root.forEach((Div) => {
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <App domElement={Div} />
      </Provider>
    </React.StrictMode>,
    Div
  )
});


